import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { InteractiveTableAddon } from './components/interactive-table-addon';

const interactiveTableAddon = AddonBlueprint.make({
  name: 'interactive-table',
  params: {
    name: 'InteractiveTable',
    location: TechDocsAddonLocations.Content,
    component: InteractiveTableAddon,
  },
});

/** @alpha */
export const techDocsInteractiveTableAddonModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [interactiveTableAddon],
});

export default techDocsInteractiveTableAddonModule;
